<template>
  <AuthLayout
    :title="props.invited ? 'Set Up Your Account' : 'Reset Password'"
    :heading="props.invited ? 'Welcome to AirSchedule' : null"
  >
    <ParagraphText v-if="props.invited" class="mb-6" color="text-gray-500"
      >Choose a password to finish setting up your account. You'll use it with
      your email address to log in.</ParagraphText
    >

    <form class="space-y-6" @submit.prevent="submit">
      <div>
        <InputGroup
          v-model="form.email"
          type="email"
          label="Email address"
          :error="form.errors.email"
          disabled
        />
      </div>

      <div>
        <InputGroup
          v-model="form.password"
          type="password"
          label="Password"
          :error="form.errors.password"
          autocomplete="new-password"
          required
        />
      </div>

      <div>
        <InputGroup
          v-model="form.password_confirmation"
          type="password"
          label="Confirm password"
          :error="form.errors.password_confirmation"
          autocomplete="new-password"
          required
        />
      </div>
      <div>
        <ButtonBase
          type="submit"
          class="w-full justify-center"
          :processing="form.processing"
          >{{ props.invited ? 'Set Password' : 'Reset Password' }}</ButtonBase
        >
      </div>
    </form>
  </AuthLayout>
</template>

<script setup>
import { useForm } from '@inertiajs/inertia-vue3'

import AuthLayout from '@/Layouts/AuthLayout.vue'
import ButtonBase from '@/Common/Elements/Buttons/ButtonBase.vue'
import InputGroup from '@/Common/Forms/Inputs/InputGroup.vue'
import ParagraphText from '@/Common/Text/ParagraphText.vue'

const props = defineProps({
  email: String,
  token: String,
  invited: Boolean,
})

const form = useForm({
  email: props.email,
  token: props.token,
  password: null,
  password_confirmation: null,
})

function submit() {
  form.post(route('password.update'), {
    onSuccess: () => form.reset(),
  })
}
</script>
